const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const sendEmail = input => {
  const query = `mutation sendEmail(
      $input: SendEmailInput
    ) {
      sendEmail(
        input: $input,
      ) { 
        success
        recipient
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, input)
}
